// tools and component for date picker
import dayjs from 'dayjs';

//import Fetch API functions
import { getStockPeriode, getArticles} from '../database/fetchApi.js' //params (date1,date2)

export async function getAllStock(date1,date2) {

let response = await getStockPeriode(date1,date2);
let articles = await getArticles();

return getAllData(response,date1,date2,articles);



}


function getAllData(allStocks,date1,date2,articles) {

    let dureeJours = dayjs(date2).diff(date1, 'day');
        let qteCreneaux = (dureeJours+1)*12
        console.log("crens",qteCreneaux);

    let stockSet = [];
    articles.forEach(article => {
        stockSet[article.id_article] = new Array(qteCreneaux);
    });


    allStocks.map((contrat) => {

        // index => 12 par jour x la duree de la loc
        //startIndex 0=>jourX12-1
        
        let contratStartDayNumber = dayjs(contrat.date1).diff(date2, 'day') + dureeJours;
        contratStartDayNumber=contratStartDayNumber<0?0:contratStartDayNumber;
        //console.log(contratStartDayNumber);
        let contratStartIndex = contratStartDayNumber * 12;
        //console.log(contratStartIndex);


        //endIndex 0=>83
        let contratEndDayNumber = dayjs(contrat.date2).diff(date2, 'day') /* + dureeJours */;
        contratEndDayNumber=contratEndDayNumber>0?0:contratEndDayNumber;
        //console.log(contratEndDayNumber);
        
        let contratEndIndex = (dureeJours + contratEndDayNumber+1) * 12 ;
        //console.log(contratEndIndex);


        contrat.ContratArticles.forEach(article => {

            for (let creneau = contratStartIndex; creneau < contratEndIndex; creneau++) {

                
                    let amount = stockSet[article.article_id][creneau] || 0;
                    amount += article.qte;
                    stockSet[article.article_id][creneau] = amount;

            }
            

        });

    }) //end of map stocks semaine

    // stockset est tableaudouble entrée id_article/qte du creneau
    //console.log(stockSet);
    let result = [];
    stockSet.forEach((article,index)=>{
        /* let temp=[1,2,3,4];
            console.log(temp.toSorted((n1,n2)=>n1>n2?0:1)[0]); */
        result.push({article_id:index,qte:article.toSorted((n1,n2)=>n1>n2?0:1)[0]||0});
    });

    //console.log(result);
    return result;

}